import { render, staticRenderFns } from "./PreviewInPageButtons.vue?vue&type=template&id=3519185b&"
import script from "./PreviewInPageButtons.vue?vue&type=script&lang=js&"
export * from "./PreviewInPageButtons.vue?vue&type=script&lang=js&"
import style0 from "./PreviewInPageButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PreviewInPageButtons.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/PreviewInPageButtons.vue
// module id = 2305
// module chunks = 1